module.exports = __webpack_public_path__ + "static/media/tacometro-alto.7908fdc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/tacometro-alto.svg
// module id = 148
// module chunks = 0